import { render, staticRenderFns } from "./IframeAppointment.vue?vue&type=template&id=128abeba"
import script from "./IframeAppointment.vue?vue&type=script&lang=js"
export * from "./IframeAppointment.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports